angular.module('inspecciones')
    .value('_env', window.__env || {})
    .controller('inspeccionTunelADIFController', ['$rootScope', '$scope', '$location', '$route', '$routeParams', 'inspeccionesService', 'TVService', 'infraestructurasService', 'infraestructurasAdminService', 'authenticationInfo', 'authenticationService', '$sce', '$timeout',
        function ($rootScope, $scope, $location, $route, $routeParams, inspeccionesService, TVService, infraestructurasService, infraestructurasAdminService, authenticationInfo, authenticationService, $sce, $timeout) {


            $scope.adjuntos = [];

            $scope.pestanyaDanos = 'listado';

            $scope.pestanyaInspeccionar = 'nube';
            $scope.visorDxfUrl = null;

            $scope.mostrarNubePuntos = function () {
                $scope.pestanyaInspeccionar = 'nube';
            };

            $scope.mostrarPlanoDxf = function () {
                $scope.pestanyaInspeccionar = 'dxf';

                var apiRoot = (
                    (window.__env && window.__env.apiUrl) ||
                    window.location.origin
                )
                    .replace(/\/$/, '');

                var urlbase =
                    apiRoot +
                    '/inspeccionesTunelADIF/visor-dxf';

                var urlVisor =
                    '/app/visor-dxf/index.html' +
                    '?insp=' + encodeURIComponent($scope.InspeccionId) +
                    '&base=' + encodeURIComponent(urlbase);


                inspeccionesService
                    .getDWGTunelADIF(
                        $scope.InspeccionId,
                        'plano.dxf'
                    )
                    .then(function (response) {
                        console.log(
                            'DXF recibido:',
                            response.status,
                            response.data.byteLength
                        );
                    })
                    .catch(function (error) {
                        console.error(
                            'Error obteniendo el DXF:',
                            error.status,
                            error
                        );
                    });


                console.log('URL del visor DXF:', urlVisor);

                $scope.visorDxfUrl =
                    $sce.trustAsResourceUrl(urlVisor);
            };


            // --- Puente con el visor DXF (Opción B) ---
            function onVisorMsg(e) {
                if (!e.data || e.data.type !== 'visorListo') return;

                var token = authentication.token;         // el access_token que ya guarda la app
                var apiBase = 'https://localhost:44387/';    // base de la API

                $http.get(apiBase + 'damagesADIF/inspeccion/' + e.data.insp, {
                    headers: { Authorization: 'Bearer ' + token }
                }).then(function (r) {
                    e.source.postMessage({ type: 'danosBD', danos: r.data }, '*');
                });
            }

            window.addEventListener('message', onVisorMsg);

            // Importante: quitarlo al salir, para no apilar listeners duplicados.
            $scope.$on('$destroy', function () {
                window.removeEventListener('message', onVisorMsg);
            });


            // El visor avisa cuando termina de cargar el DXF. En ese momento
            // le enviamos los daños reales para cruzarlos por NumBloqueDXF.
            var manejarMensajeVisorDxf = function (event) {
                var mensaje = event.data;

                if (!mensaje || mensaje.type !== 'visorListo') {
                    return;
                }

                if (String(mensaje.insp) !== String($scope.InspeccionId)) {
                    return;
                }

                var enviarDanos = function (danos) {
                    if (!event.source) {
                        return;
                    }

                    event.source.postMessage(
                        {
                            type: 'danosBD',
                            danos: danos || []
                        },
                        event.origin && event.origin !== 'null'
                            ? event.origin
                            : '*'
                    );
                };

                if ($scope.danosCargados) {
                    enviarDanos($scope.damagesADIF);
                    return;
                }

                inspeccionesService
                    .getDañosADIF($scope.InspeccionId)
                    .then(function (response) {
                        var datos = response.data || [];
                        $scope.damagesADIF = datos.map($scope.prepararDamage);
                        $scope.danosCargados = true;
                        $scope.paginaActual = 1;
                        $scope.actualizarPaginaDanos();
                        enviarDanos($scope.damagesADIF);
                    })
                    .catch(function (error) {
                        console.error('Error enviando daños al visor DXF:', error);
                        enviarDanos([]);
                    });
            };

            window.addEventListener('message', manejarMensajeVisorDxf);

            $scope.$on('$destroy', function () {
                window.removeEventListener('message', manejarMensajeVisorDxf);
            });

            $scope.mostrarListadoDanos = function () {
                $scope.pestanyaDanos = 'listado';
            };

            // $scope.mostrarDWGDanos = function () {
            //     $scope.pestanyaDanos = 'visor';
            // };

            $scope.refrescarAdjuntos =
                function () {

                    $scope.pestanyamenuinspeccion =
                        'adjuntos';

                    $scope.cargarAdjuntos();
                };


            $scope.cargarAdjuntos =
                function () {

                    inspeccionesService
                        .getAdjuntos(
                            $scope.InspeccionId
                        )
                        .then(
                            function (response) {

                                $scope.adjuntos =
                                    response.data ||
                                    [];

                            }
                        )
                        .catch(
                            function (error) {

                                console.error(
                                    'Error cargando adjuntos:',
                                    error
                                );

                                $scope.adjuntos = [];
                            }
                        );
                };


            $scope.subirAdjuntos =
                function (archivos) {

                    if (
                        !archivos ||
                        archivos.length === 0
                    ) {
                        return;
                    }


                    document.body
                        .classList
                        .add(
                            'cargando-tuneles-adif'
                        );


                    inspeccionesService
                        .subirAdjuntos(
                            $scope.InspeccionId,
                            archivos
                        )
                        .then(
                            function () {

                                return $scope
                                    .cargarAdjuntos();

                            }
                        )
                        .then(
                            function () {

                                alert(
                                    'Documentos subidos correctamente'
                                );

                            }
                        )
                        .catch(
                            function (error) {

                                console.error(
                                    'Error subiendo adjuntos:',
                                    error
                                );

                                alert(
                                    'No se han podido subir los documentos.'
                                );

                            }
                        )
                        .finally(
                            function () {

                                document.body
                                    .classList
                                    .remove(
                                        'cargando-tuneles-adif'
                                    );

                            }
                        );
                };


            $scope.descargarAdjunto =
                function (adjunto) {

                    inspeccionesService
                        .descargarAdjunto(
                            $scope.InspeccionId,
                            adjunto.Nombre
                        )
                        .then(
                            function (response) {

                                var blob =
                                    new Blob(
                                        [response.data],
                                        {
                                            type:
                                                'application/octet-stream'
                                        }
                                    );


                                var url =
                                    window.URL
                                        .createObjectURL(
                                            blob
                                        );


                                var enlace =
                                    document
                                        .createElement(
                                            'a'
                                        );


                                enlace.href =
                                    url;

                                enlace.download =
                                    adjunto.Nombre;


                                document.body
                                    .appendChild(
                                        enlace
                                    );


                                enlace.click();


                                document.body
                                    .removeChild(
                                        enlace
                                    );


                                window.URL
                                    .revokeObjectURL(
                                        url
                                    );
                            }
                        );
                };


            $scope.eliminarAdjunto =
                function (adjunto) {

                    if (
                        !confirm(
                            '¿Seguro que deseas eliminar "' +
                            adjunto.Nombre +
                            '"?'
                        )
                    ) {
                        return;
                    }


                    inspeccionesService
                        .eliminarAdjunto(
                            $scope.InspeccionId,
                            adjunto.Nombre
                        )
                        .then(
                            function () {

                                return $scope
                                    .cargarAdjuntos();

                            }
                        )
                        .catch(
                            function (error) {

                                console.error(
                                    'Error eliminando adjunto:',
                                    error
                                );

                                alert(
                                    'No se ha podido eliminar el documento.'
                                );
                            }
                        );
                };


            $scope.mostrar = function (loader) {
                var elemento =
                    document.getElementById(loader);

                if (elemento) {
                    elemento.style.display = 'block';
                }
            };

            $scope.ocultar = function (loader) {
                var elemento =
                    document.getElementById(loader);

                if (elemento) {
                    elemento.style.display = 'none';
                }
            };

            $scope.exportarDanosInspeccionExcel = function () {
                if (!$scope.InspeccionId) {
                    return;
                }

                document.body.classList.add('cargando-tuneles-adif');


                inspeccionesService.exportarDanosInspeccionExcel($scope.InspeccionId)
                    .then(function (response) {
                        var blob =
                            new Blob(
                                [response.data],
                                {
                                    type:
                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                }
                            );


                        var url =
                            window.URL.createObjectURL(
                                blob
                            );


                        var enlace = document.createElement('a');
                        enlace.href = url;
                        var fecha = new Date();
                        var fechaTexto =
                            fecha.getFullYear() +
                            '-' +
                            ('0' + (fecha.getMonth() + 1))
                                .slice(-2) +
                            '-' +
                            ('0' + fecha.getDate())
                                .slice(-2);


                        enlace.download =
                            'Danos_Inspeccion_' +
                            $scope.InspeccionId +
                            '_' +
                            fechaTexto +
                            '.xlsx';


                        document.body.appendChild(
                            enlace
                        );
                        enlace.click();
                        document.body.removeChild(enlace);
                        window.URL.revokeObjectURL(url);

                    })
                    .catch(function (error) {
                        console.error(
                            'Error exportando daños:',
                            error
                        );
                        alert(
                            'No se ha podido generar el Excel de daños.'
                        );
                    })
                    .finally(function () {
                        document.body.classList.remove('cargando-tuneles-adif');
                    });
            };

            $scope.damageBarChartSeccion = null;

            $scope.authentication = authenticationInfo;

            $scope.InspeccionId = $routeParams.id;

            $scope.min = 10;
            $scope.max = 300;
            $scope.step = 10;
            $scope.seccion = 100;
            $scope.hoverValue = 100;
            $scope.tooltipStyle = { display: "none" };

            inspeccionesService.getTunelId($rootScope.InfraestructuraId)
                .then(function (response) {
                    $scope.TunelId = response.data;
                });


            infraestructurasAdminService.getPropietarios()
                .then(function (response) {
                    var data = response.data;
                    $scope.propietarios = data;
                });

            infraestructurasAdminService.getInspectores()
                .then(function (response) {
                    var data = response.data;
                    $scope.inspectores = data;
                });


            $scope.indice = 0;

            if ($scope.InspeccionId > 0) {
                inspeccionesService.getInspeccionTunelADIF($scope.InspeccionId)
                    .then(function (response) {
                        var data = response.data;
                        $scope.inspeccion = data;
                        $scope.inspeccion.Descripcion = $scope.inspeccion.Descripcion.toString();
                        $scope.inspeccion.IndiceTubo = $scope.inspeccion.IndiceTubo.toString();
                        $scope.inspeccion.FechaInicio = $scope.inspeccion.FechaInicio.toString();
                        $scope.inspeccion.FechaFin = $scope.inspeccion.FechaFin ? $scope.inspeccion.FechaFin.toString() : ''; // Verificación específica
                        //$scope.inspeccion.FechaInspAnterior = $scope.inspeccion.FechaInspAnterior ? $scope.inspeccion.FechaInspAnterior.toString() : ''; // Verificación específica
                        $scope.inspeccion.FechaInspAnterior = dateFormat($scope.inspeccion.FechaInspAnterior, "dd/mm/yyyy");
                        $scope.inspeccion.NumTramos = $scope.inspeccion.NumTramos;
                        $scope.inspeccion.LongTramo = $scope.inspeccion.LongTramo;
                        //$scope.inspeccion.Inspector = $scope.inspeccion.Inspector.toString();
                        //$scope.inspeccion.Propietario = $scope.inspeccion.Propietario.toString();
                        $scope.inspeccion.InspectorId = $scope.inspeccion.InspectorId.toString();
                        $scope.inspeccion.PropietarioId = $scope.inspeccion.PropietarioId.toString();
                        // $scope.inspeccion.TunelId = $scope.TunelId.toString();
                        $scope.inspeccion.IdentificadorTubo = $scope.inspeccion.TunelADIF.IdentificadorTubo.toString();
                        $scope.inspeccion.Comentarios = $scope.inspeccion.Comentarios.toString();

                    })
            }

            // para mostrar 100 daños por pagina

            $scope.damagesADIF = [];
            $scope.damagesPagina = [];

            $scope.paginaActual = 1;
            $scope.tamanoPagina = 100;
            $scope.totalPaginas = 0;
            $scope.danosCargados = false;

            $scope.prepararDamage = function (damage) {
                damage.CantidadUnidades = damage.Cantidad
                    ? damage.Cantidad + (damage.Unidades ? ' ' + damage.Unidades : '')
                    : (damage.Unidades || '');

                /*
                 * Temporalmente admite Imagen o TieneImagen.
                 * Cuando modifiques la API, utiliza solamente TieneImagen.
                 */
                //damage.TieneImagen = damage.TieneImagen === true ||
                //    damage.Imagen !== null &&
                //    damage.Imagen !== undefined &&
                //    damage.Imagen !== '';

                return damage;
            };

            $scope.actualizarPaginaDanos = function () {
                var inicio = ($scope.paginaActual - 1) * $scope.tamanoPagina;
                var fin = inicio + $scope.tamanoPagina;

                $scope.damagesPagina = $scope.damagesADIF.slice(inicio, fin);

                $scope.totalPaginas = Math.ceil(
                    $scope.damagesADIF.length / $scope.tamanoPagina
                );

                if ($scope.totalPaginas === 0) {
                    $scope.totalPaginas = 1;
                }
            };

            $scope.cambiarPagina = function (pagina) {
                if (pagina < 1 || pagina > $scope.totalPaginas) {
                    return;
                }

                $scope.paginaActual = pagina;
                $scope.actualizarPaginaDanos();
            };

            $scope.refrescarDanos = function (forzarRecarga) {
                $scope.pestanyamenuinspeccion =
                    'danosgenerales';

                /*
                 * Si ya están cargados, no volvemos a consultar
                 * la API y por tanto tampoco mostramos el reloj.
                 */
                if (
                    $scope.danosCargados &&
                    !forzarRecarga
                ) {
                    return;
                }

                document.body.classList.add('cursor-cargando');

                $scope.mostrar('loader-seguimiento');

                inspeccionesService.getDañosADIF($scope.InspeccionId)
                    .then(function (response) {
                        var datos =
                            response.data || [];
                        $scope.damagesADIF =
                            datos.map(
                                $scope.prepararDamage
                            );
                        $scope.paginaActual = 1;
                        $scope.danosCargados = true;
                        $scope.actualizarPaginaDanos();
                    })
                    .catch(function (error) {
                        console.error(
                            'Error cargando los daños:',
                            error
                        );
                        $scope.damagesADIF = [];
                        $scope.damagesPagina = [];
                    })
                    .finally(function () {
                        $scope.ocultar(
                            'loader-seguimiento'
                        );
                        document.body.classList.remove('cursor-cargando');
                    });
            };


            if ($rootScope.damageUrl === true) {

                var pestanyaOrigen =
                    $rootScope.pestanyaOrigenDamage ||
                    'danosgenerales';

                $scope.pestanyamenuinspeccion =
                    pestanyaOrigen;

                $rootScope.damageUrl = false;

                /*
                 * Se usa $timeout porque las funciones
                 * refrescarPorPk(), refrescarPorTipo(), etc.
                 * se definen más adelante en el controlador.
                 */
                $timeout(function () {
                    switch (pestanyaOrigen) {
                        case 'dañosporpk':
                            $scope.refrescarPorPk();
                            break;
                        case 'dañosportipo':
                            $scope.refrescarPorTipo();
                            break;
                        case 'dañosporelemento':
                            $scope.refrescarPorElemento();
                            break;
                        case 'dañosporseccion':
                            $scope.refrescarPorSeccion();
                            break;
                        case 'reparaciones':
                            $scope.refrescarReparaciones();
                            break;
                        case 'danosgenerales':
                        default:
                            $scope.refrescarDanos();
                            break;
                    }
                }, 0);
            }
            else {

                $scope.pestanyamenuinspeccion = 'general';
            }


            TVService.getSitioInspeccionADIF($scope.InspeccionId)
                .then(function (response) {
                    var data = response.data;
                    $scope.sitio = data;
                    //   $scope.sitioUrl = $sce.trustAsHtml("<iframe src='https://nube.infraestructuradigital.es/views/EntornoPruebasv2.html' style='width: 100%; height: 800px'></iframe>");
                    $scope.sitioUrl = $sce.trustAsHtml($scope.sitio);
                });


            // infraestructurasService.getDañosADIFPorTipo($scope.InspeccionId)
            //     .then(function (response) {
            //         $scope.dañosportipo = response.data;

            //         // Generar dinámicamente los labels y los datos basados en $scope.daños
            //         const labels = $scope.dañosportipo.map(function (d) {
            //             return d.Tipo.Descripcion || 'N/A';
            //         });

            //         const data = $scope.dañosportipo.map(function (d) {
            //             return d.Conteo || 0;
            //         });

            //         // Generar colores dinámicamente si hay más de 3 tipos de daños
            //         const backgroundColors = labels.map(function (_, i) {
            //             return 'rgba(' +
            //                 Math.floor(Math.random() * 255) + ', ' +
            //                 Math.floor(Math.random() * 255) + ', ' +
            //                 Math.floor(Math.random() * 255) + ', 0.7)';
            //         });

            //         const borderColors = [];
            //         for (var i = 0; i < labels.length; i++) {
            //             borderColors.push(
            //                 'rgba(' +
            //                 Math.floor(Math.random() * 255) + ', ' +
            //                 Math.floor(Math.random() * 255) + ', ' +
            //                 Math.floor(Math.random() * 255) + ', 1)'
            //             );
            //         }

            //         // Configuración de los datos del gráfico
            //         const damageData = {
            //             labels: labels, // Etiquetas dinámicas
            //             datasets: [{
            //                 label: 'Distribución de Daños',
            //                 data: data, // Datos dinámicos
            //                 backgroundColor: backgroundColors,
            //                 borderColor: borderColors,
            //                 borderWidth: 1
            //             }]
            //         };

            //         // Configuración del gráfico
            //         const config = {
            //             type: 'pie',
            //             data: damageData,
            //             options: {
            //                 responsive: true,
            //                 plugins: {
            //                     legend: {
            //                         display: false, // Oculta la leyenda
            //                     },
            //                     tooltip: {
            //                         enabled: true, // Mostrar valores al pasar el mouse
            //                     },
            //                     datalabels: {
            //                         color: '#000', // Color del texto
            //                         font: {
            //                             size: 12, // Tamaño del texto
            //                             weight: 'bold'
            //                         },
            //                         formatter: function (value, ctx) {
            //                             // Calcula el porcentaje
            //                             const total = ctx.chart.data.datasets[0].data.reduce(function (sum, val) {
            //                                 return sum + val;
            //                             }, 0);
            //                             const percentage = ((value / total) * 100).toFixed(2);
            //                             return percentage + '%'; // Devuelve el porcentaje
            //                         }
            //                     }
            //                 },
            //                 layout: {
            //                     padding: 20 // Añade espacio alrededor del gráfico
            //                 }
            //             }
            //         };

            //         // Creación del gráfico
            //         const ctx = document.getElementById('graficoDaniosPorTipo').getContext('2d');
            //         const damagePieChart = new Chart(ctx, config);
            //     });


            // infraestructurasService.getDañosADIFPorGravedad($scope.InspeccionId)
            //     .then(function (response) {
            //         $scope.dañosporgravedad = response.data;

            //         // Generar dinámicamente los labels y los datos basados en $scope.daños
            //         const labelsGr = $scope.dañosporgravedad.map(function (d) {
            //             return d.GravedadDaño || 'N/A';
            //         });

            //         const dataGr = $scope.dañosporgravedad.map(function (d) {
            //             return d.Conteo || 0;
            //         });

            //         const colorMap = {
            //             'Leve': 'rgba(0, 128, 0, 0.7)',         // Verde
            //             'Moderado': 'rgba(255, 255, 0, 0.7)',   // Amarillo
            //             'Severo': 'rgba(255, 165, 0, 0.7)',     // Naranja
            //             'Critico': 'rgba(255, 0, 0, 0.7)'       // Rojo
            //         };

            //         const darkerColorMap = {
            //             'Leve': 'rgba(0, 100, 0, 1)',           // Verde oscuro
            //             'Moderado': 'rgba(200, 200, 0, 1)',     // Amarillo oscuro
            //             'Severo': 'rgba(200, 100, 0, 1)',       // Naranja oscuro
            //             'Critico': 'rgba(150, 0, 0, 1)'         // Rojo oscuro
            //         };

            //         // Generar colores de fondo
            //         var backgroundColorsGr = labelsGr.map(function (label) {
            //             return colorMap[label];
            //         });

            //         // Generar colores de borde
            //         var borderColorsGr = labelsGr.map(function (label) {
            //             return darkerColorMap[label];
            //         });


            //         // Configuración de los datos del gráfico
            //         const damageDataGr = {
            //             labels: labelsGr, // Etiquetas dinámicas
            //             datasets: [{
            //                 label: 'Distribución de Daños',
            //                 data: dataGr, // Datos dinámicos
            //                 backgroundColor: backgroundColorsGr,
            //                 borderColor: borderColorsGr,
            //                 borderWidth: 1
            //             }]
            //         };

            //         // Configuración del gráfico
            //         const configGr = {
            //             type: 'pie',
            //             data: damageDataGr,
            //             options: {
            //                 responsive: true,
            //                 plugins: {
            //                     legend: {
            //                         display: false, // Oculta la leyenda
            //                     },
            //                     tooltip: {
            //                         enabled: true, // Mostrar valores al pasar el mouse
            //                     },
            //                     datalabels: {
            //                         color: '#000', // Color del texto
            //                         font: {
            //                             size: 12, // Tamaño del texto
            //                             weight: 'bold'
            //                         },
            //                         formatter: function (value, ctx) {
            //                             // Calcula el porcentaje
            //                             const total = ctx.chart.data.datasets[0].data.reduce(function (sum, val) {
            //                                 return sum + val;
            //                             }, 0);
            //                             const percentage = ((value / total) * 100).toFixed(2);
            //                             return percentage + '%'; // Devuelve el porcentaje
            //                         }
            //                     }
            //                 },
            //                 layout: {
            //                     padding: 20 // Añade espacio alrededor del gráfico
            //                 }
            //             }
            //         };

            //         // Creación del gráfico
            //         const ctxGr = document.getElementById('graficoDaniosPorGravedad').getContext('2d');
            //         const damagePieChartGr = new Chart(ctxGr, configGr);
            //     });

            // infraestructurasService.getDañosADIFPorElemento($scope.InspeccionId)
            //     .then(function (response) {
            //         $scope.dañosporelemento = response.data;

            //         // Generar dinámicamente los labels y los datos basados en $scope.daños
            //         const labels = $scope.dañosporelemento.map(function (d) {
            //             return d.Elemento.Descripcion || 'N/A';
            //         });

            //         const data = $scope.dañosporelemento.map(function (d) {
            //             return d.Conteo || 0;
            //         });

            //         // Generar colores dinámicamente si hay más de 3 tipos de daños
            //         const backgroundColors = labels.map(function (_, i) {
            //             return 'rgba(' +
            //                 Math.floor(Math.random() * 255) + ', ' +
            //                 Math.floor(Math.random() * 255) + ', ' +
            //                 Math.floor(Math.random() * 255) + ', 0.7)';
            //         });

            //         const borderColors = [];
            //         for (var i = 0; i < labels.length; i++) {
            //             borderColors.push(
            //                 'rgba(' +
            //                 Math.floor(Math.random() * 255) + ', ' +
            //                 Math.floor(Math.random() * 255) + ', ' +
            //                 Math.floor(Math.random() * 255) + ', 1)'
            //             );
            //         }

            //         // Configuración de los datos del gráfico
            //         const damageData = {
            //             labels: labels, // Etiquetas dinámicas
            //             datasets: [{
            //                 label: 'Distribución de Daños',
            //                 data: data, // Datos dinámicos
            //                 backgroundColor: backgroundColors,
            //                 borderColor: borderColors,
            //                 borderWidth: 1
            //             }]
            //         };

            //         // Configuración del gráfico
            //         const config = {
            //             type: 'pie',
            //             data: damageData,
            //             options: {
            //                 responsive: true,
            //                 plugins: {
            //                     legend: {
            //                         display: false, // Oculta la leyenda
            //                     },
            //                     tooltip: {
            //                         enabled: true, // Mostrar valores al pasar el mouse
            //                     },
            //                     datalabels: {
            //                         color: '#000', // Color del texto
            //                         font: {
            //                             size: 12, // Tamaño del texto
            //                             weight: 'bold'
            //                         },
            //                         formatter: function (value, ctx) {
            //                             // Calcula el porcentaje
            //                             const total = ctx.chart.data.datasets[0].data.reduce(function (sum, val) {
            //                                 return sum + val;
            //                             }, 0);
            //                             const percentage = ((value / total) * 100).toFixed(2);
            //                             return percentage + '%'; // Devuelve el porcentaje
            //                         }
            //                     }
            //                 },
            //                 layout: {
            //                     padding: 20 // Añade espacio alrededor del gráfico
            //                 }
            //             }
            //         };

            //         // Creación del gráfico
            //         const ctx = document.getElementById('graficoDaniosPorElemento').getContext('2d');
            //         const damagePieChart = new Chart(ctx, config);
            //     });





            $scope.verDamage = function (idDaño) {
                // Guardar la pestaña desde la que hemos abierto el daño
                $rootScope.pestanyaOrigenDamage = $scope.pestanyamenuinspeccion;
                $location.url('/damagesADIF/' + $scope.InspeccionId + '/' + idDaño);
            };

            $scope.validarSeleccion = function () {
                if (!$scope.informeSeleccionado) {
                    // Si no se selecciona un informe, muestra una alerta
                    alert("Por favor, seleccione un informe antes de continuar.");
                    return;
                }
                $scope.imprimirInforme();
            };


            $scope.imprimirInforme = function () {
                if ($scope.informeSeleccionado == "Listado Daños") {
                    infraestructurasService.getListado($scope.InspeccionId)
                        .then(function (data, status, headers) {

                            var filename = "Listado de Daños por Inspeccion.doc";
                            var contentType = 'application/msword';

                            var blob = new Blob([data.data],
                                { type: contentType });

                            if (navigator.appVersion.toString().indexOf('.NET') > 0) //IE
                                window.navigator.msSaveBlob(blob, filename);
                            else //Resto
                            {
                                var downloadLink = document.createElement("a");
                                var url = window.URL.createObjectURL(blob);
                                downloadLink.setAttribute("target", "_blank");
                                downloadLink.setAttribute("href", url);
                                downloadLink.setAttribute("download", filename);
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                                elemento.style.display = 'none';
                            }
                        })
                }
                else {
                    infraestructurasService.getInforme($scope.InspeccionId)
                        .then(function (data, status, headers) {
                            var filename = "Informe inspeccion.doc";
                            var contentType = 'application/msword';

                            var blob = new Blob([data.data],
                                { type: contentType });

                            if (navigator.appVersion.toString().indexOf('.NET') > 0) //IE
                                window.navigator.msSaveBlob(blob, filename);
                            else //Resto
                            {
                                var downloadLink = document.createElement("a");
                                var url = window.URL.createObjectURL(blob);
                                downloadLink.setAttribute("target", "_blank");
                                downloadLink.setAttribute("href", url);
                                downloadLink.setAttribute("download", filename);
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                                elemento.style.display = 'none';
                            }
                        })
                }
            }


            $scope.eliminarDamage = function (idDaño) {
                var confirmar = confirm('¿Seguro que deseas eliminar este daño?');

                if (!confirmar) {
                    return;
                }

                inspeccionesService.eliminarDamage(idDaño)
                    .then(function () {
                        $scope.danosCargados = false;
                        return $scope.refrescarDanos(true);
                    })
                    .catch(function (error) {
                        console.error('Error eliminando el daño:', error);
                        alert('No se ha podido eliminar el daño.');
                    });
            }


            $scope.volver = function () {
                if ($scope.inspeccion &&
                    $scope.inspeccion.Tunel) {
                    $location.path(
                        '/infraestructura/tunelADIF/' +
                        $scope.inspeccion.Tunel.Id
                    );
                }
            };


            $scope.tablaprecios = function () {
                $location.path('/admin/preciosAdmin');
            }


            $scope.guardar = function (mostrarAlerta) {
                const timeElapsed = Date.now();
                const today = new Date(timeElapsed);

                var inspeccionSQL = new Object();
                inspeccionSQL.Id = $scope.InspeccionId;
                inspeccionSQL.Descripcion = $scope.inspeccion.Descripcion;
                inspeccionSQL.IndiceTubo = $scope.inspeccion.IndiceTubo;
                inspeccionSQL.IdentificadorTubo = $scope.inspeccion.IdentificadorTubo;
                inspeccionSQL.FechaInicio = $scope.inspeccion.FechaInicio;
                inspeccionSQL.FechaFin = $scope.inspeccion.FechaFin ? $scope.inspeccion.FechaFin : ''; // Verificación específica
                inspeccionSQL.NumTramos = $scope.inspeccion.NumTramos;
                inspeccionSQL.LongTramo = $scope.inspeccion.LongTramo;
                inspeccionSQL.InspectorId = $scope.inspeccion.InspectorId;
                inspeccionSQL.PropietarioId = $scope.inspeccion.PropietarioId;
                inspeccionSQL.Comentarios = $scope.inspeccion.Comentarios;

                inspeccionSQL.TunelADIFId = $scope.inspeccion.TunelADIFId;

                // Validar que todos los valores sean numéricos
                if (!isNaN($scope.inspeccion.NumTramos) &&
                    !isNaN($scope.inspeccion.LongTramo)) {
                    if (!$scope.inspeccion.FechaInicio) {
                        alert("Debe introducir la Fecha de Inicio de la inspección.");
                        return; // Salir si las fechas no son válidas
                    }
                    $scope.mostrar('loader-seguimiento');
                    // Convertir a números y luego a cadena
                    // $scope.inspeccion.IndiceTubo = parseInt($scope.inspeccion.IndiceTubo, 10).toString();
                    $scope.inspeccion.NumTramos = $scope.inspeccion.NumTramos;
                    $scope.inspeccion.LongTramo = $scope.inspeccion.LongTramo;


                    var esNuevaInspeccion = Number($scope.InspeccionId) === 0;

                    inspeccionesService.putInspeccionTunelADIF(inspeccionSQL)
                        .then(function (response) {
                            if (esNuevaInspeccion) {
                                $scope.InspeccionId = response.data;
                            }

                            $routeParams.id = $scope.InspeccionId;

                            return inspeccionesService.getInspeccionTunelADIF(
                                $scope.InspeccionId
                            );
                        })
                        .then(function (responseRecarga) {
                            var data = responseRecarga.data;

                            $scope.inspeccion = data;

                            $scope.inspeccion.Descripcion =
                                data.Descripcion != null
                                    ? data.Descripcion.toString()
                                    : '';

                            $scope.inspeccion.IndiceTubo =
                                data.IndiceTubo != null
                                    ? data.IndiceTubo.toString()
                                    : '';

                            $scope.inspeccion.FechaInicio =
                                data.FechaInicio || '';

                            $scope.inspeccion.FechaFin =
                                data.FechaFin || '';

                            $scope.inspeccion.FechaInspAnterior =
                                data.FechaInspAnterior
                                    ? dateFormat(
                                        data.FechaInspAnterior,
                                        'dd/mm/yyyy'
                                    )
                                    : '';

                            $scope.inspeccion.InspectorId =
                                data.InspectorId != null
                                    ? data.InspectorId.toString()
                                    : '';

                            $scope.inspeccion.PropietarioId =
                                data.PropietarioId != null
                                    ? data.PropietarioId.toString()
                                    : '';

                            $scope.inspeccion.IdentificadorTubo =
                                data.IdentificadorTubo != null
                                    ? data.IdentificadorTubo.toString()
                                    : '';

                            $scope.inspeccion.Comentarios =
                                data.Comentarios || '';

                            $scope.ocultar('loader-seguimiento');

                            if (mostrarAlerta) {
                                alert('Los datos se han guardado correctamente');
                            }

                            if (esNuevaInspeccion) {
                                $location.url(
                                    '/inspeccionesADIF/' + $scope.InspeccionId
                                );
                            }
                        })
                        .catch(function (error) {
                            $scope.ocultar('loader-seguimiento');

                            console.error(
                                'Error guardando o recargando la inspección:',
                                error
                            );

                            alert(
                                'No se han podido guardar o recargar los datos ' +
                                'de la inspección.'
                            );
                        });
                } else {
                    alert("Compruebe que los valores Numero de Tramos y Longitud de Tramo sean numéricos");
                }

            };

            $scope.logout = function () {
                return authenticationService.logout();
            }


            $scope.refrescarGeneral = function () {
                $scope.pestanyavisible = 'general';
                $scope.pestanyamenuinspeccion = 'general';

            }

            $scope.refrescarInspeccionar = function () {
                $scope.pestanyamenuinspeccion = 'inspeccionar';
            }


            $scope.refrescarPorPk = function () {
                $scope.pestanyamenuinspeccion = 'dañosporpk';
                inspeccionesService.getDañosPorPK($routeParams.id, $scope.seccion)
                    .then(function (response) {
                        $scope.damagesporpk = response.data;
                    });
            }

            $scope.refrescarPorTipo = function () {
                $scope.pestanyamenuinspeccion = 'dañosportipo';
                inspeccionesService.getDañosPorTipo($routeParams.id)
                    .then(function (response) {
                        $scope.damagesportipo = response.data;
                    });
            }


            $scope.refrescarReparaciones = function () {
                $scope.pestanyamenuinspeccion = 'reparaciones';
                inspeccionesService.getReparaciones($routeParams.id)
                    .then(function (response) {
                        $scope.damagesporreparacion = response.data;
                    });
            }


            $scope.refrescarPorElemento = function () {
                $scope.pestanyamenuinspeccion = 'dañosporelemento';
                inspeccionesService.getDañosPorElemento($routeParams.id)
                    .then(function (response) {
                        $scope.damagesporelemento = response.data;
                    });
            }

            $scope.refrescarPorSeccion = function () {
                $scope.pestanyamenuinspeccion = 'dañosporseccion';
                $scope.mostrar('loader-seguimiento-seccion');
                inspeccionesService.getDañosPorSeccion($routeParams.id, $scope.seccion)
                    .then(function (response) {
                        $scope.dañosSeccion = response.data;

                        // Generar dinámicamente los labels y los datos basados en $scope.daños
                        const labelsSec = $scope.dañosSeccion.map(function (d) {
                            return d.Seccion || 0;
                        });

                        const dataLeveSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[0].Conteo || null;
                        });

                        const dataModSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[1].Conteo || null;
                        });

                        const dataSevSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[2].Conteo || null;
                        });

                        const dataCritSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[3].Conteo || null;
                        });

                        //const labelsSeccion = { count: 7 };
                        const dataSec = {
                            labels: labelsSec,
                            datasets: [
                                {
                                    label: 'Leve',
                                    data: dataLeveSec,
                                    backgroundColor: 'rgba(0, 128, 0, 0.7)',
                                },
                                {
                                    label: 'Moderado',
                                    data: dataModSec,
                                    backgroundColor: 'rgba(255, 255, 0, 0.7)',
                                },
                                {
                                    label: 'Severo',
                                    data: dataSevSec,
                                    backgroundColor: 'rgba(255, 165, 0, 0.7)',
                                },
                                {
                                    label: 'Critico',
                                    data: dataCritSec,
                                    backgroundColor: 'rgba(255, 0, 0, 0.7)',
                                },
                            ]
                        };

                        const configSec = {
                            type: 'bar',
                            data: dataSec,
                            options: {
                                plugins: {
                                    title: {
                                        display: true,
                                        text: 'Distribución de Daños por Sección',
                                        font: {
                                            size: 16
                                        }
                                    },
                                    tooltip: {
                                        mode: 'index', // Muestra todos los valores en la misma posición de X
                                        intersect: false, // Tooltip se activa en toda la barra
                                        callbacks: {
                                            title: function () {
                                                return ''; // Oculta el valor del eje X en el tooltip
                                            },
                                            label: function (tooltipItem) {
                                                // Si el valor es null o 0, no mostrarlo
                                                if (tooltipItem.raw === null || tooltipItem.raw === 0) {
                                                    return null; // No devuelve nada (se oculta en el tooltip)
                                                }
                                                return tooltipItem.dataset.label + ': ' + tooltipItem.raw;
                                            }
                                        }
                                    }
                                },
                                interaction: {
                                    mode: 'index',
                                    intersect: false
                                },
                                responsive: true,
                                scales: {
                                    x: {
                                        stacked: true,
                                        title: {
                                            display: true,
                                            text: 'Sección (metros)', // Etiqueta del eje X
                                            font: {
                                                size: 14
                                            }
                                        },
                                        ticks: {
                                            align: 'start' // Alinea las etiquetas al inicio de cada sección
                                        },
                                        grid: {
                                            drawBorder: true,
                                            drawOnChartArea: false, // Dibuja la línea en el eje X
                                            drawTicks: true
                                        }
                                    },
                                    y: {
                                        stacked: true,
                                        title: {
                                            display: true,
                                            text: 'Cantidad de Daños', // Etiqueta del eje Y
                                            font: {
                                                size: 14
                                            }
                                        }
                                    }
                                },
                            }
                        };
                        if ($scope.damageBarChartSeccion) {
                            $scope.damageBarChartSeccion.destroy();
                        }

                        const ctxSec = document.getElementById('graficoDaniosPorSeccion').getContext('2d');
                        $scope.damageBarChartSeccion = new Chart(ctxSec, configSec);
                        $scope.ocultar('loader-seguimiento-seccion');
                    });
            }


            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };

            inspeccionesService.getSecciones($scope.InspeccionId, $scope.seccion)
                .then(function (response) {
                    $scope.secciones = response.data;
                });


            inspeccionesService.getDañosPorPosicion($scope.InspeccionId, $scope.seccion)
                .then(function (response) {

                    $scope.danosTunel = response.data;
                    var diccionario = { 'Leve': 'rgba(0, 128, 0, 0.7)', 'Moderado': 'rgba(255, 255, 0, 0.7)', 'Severo': 'rgba(255, 165, 0, 0.7)', 'Critico': 'rgba(255, 0, 0, 0.7)', '-': 'rgba(25, 31, 52, 0.2)' };

                    $scope.seccionesTunelRevest = [
                        { startAngle: -Math.PI / 2, endAngle: -Math.PI / 4, color: diccionario[$scope.danosTunel[3].PeorGravedad] }, // Hastial Izq
                        { startAngle: -Math.PI / 4, endAngle: Math.PI / 4, color: diccionario[$scope.danosTunel[1].PeorGravedad] }, // Bóveda Superior
                        { startAngle: Math.PI / 4, endAngle: Math.PI / 2, color: diccionario[$scope.danosTunel[5].PeorGravedad] }, // Hastial Der
                    ];

                    $scope.seccionesTunelPP = [
                        { startAngle: -Math.PI / 2, endAngle: -Math.PI / 4, color: diccionario[$scope.danosTunel[2].PeorGravedad] }, // Hastial Izq
                        { startAngle: -Math.PI / 4, endAngle: Math.PI / 4, color: diccionario[$scope.danosTunel[0].PeorGravedad] }, // Bóveda Superior
                        { startAngle: Math.PI / 4, endAngle: Math.PI / 2, color: diccionario[$scope.danosTunel[4].PeorGravedad] }, // Hastial Der
                    ];

                    $scope.dibujarGrafico = function () {
                        var width = 700, height = 300;
                        var svg = d3.select("#tunnelChart").attr("width", width).attr("height", height);

                        // Limpiar el SVG antes de volver a dibujar
                        svg.selectAll("*").remove();

                        var centerX = width / 2, centerY = height * 0.8, radiusPP = 180, radiusRevest = 150;

                        var arcRevest = d3.arc()
                            .innerRadius(radiusPP)
                            .outerRadius(radiusPP + 30);

                        var arcPP = d3.arc()
                            .innerRadius(radiusRevest)
                            .outerRadius(radiusRevest + 30);

                        $scope.seccionesTunelRevest.forEach(function (section) {


                            svg.append("path")
                                .attr("d", arcPP({ startAngle: section.startAngle, endAngle: section.endAngle }))
                                .attr("transform", "translate(" + centerX + "," + centerY + ")")
                                .attr("fill", section.color)
                                .attr("stroke", "black").attr("stroke-width", 1);
                        });

                        $scope.seccionesTunelPP.forEach(function (section) {

                            svg.append("path")
                                .attr("d", arcRevest({ startAngle: section.startAngle, endAngle: section.endAngle }))
                                .attr("transform", "translate(" + centerX + "," + centerY + ")")
                                .attr("fill", section.color)
                                .attr("stroke", "black").attr("stroke-width", 1);
                        });

                        // Dibujar la base del túnel PP
                        svg.append("rect")
                            .attr("x", centerX - radiusPP - 30)
                            .attr("y", centerY)
                            .attr("width", radiusPP * 2 + 60)
                            .attr("height", 25)
                            .attr("fill", diccionario[$scope.danosTunel[7].PeorGravedad])
                            .attr("stroke", "black").attr("stroke-width", 1);


                        // Dibujar la base del túnel Revestimiento
                        svg.append("rect")
                            .attr("x", centerX - radiusPP - 30)
                            .attr("y", centerY + 25)
                            .attr("width", radiusPP * 2 + 60)
                            .attr("height", 25)
                            .attr("fill", diccionario[$scope.danosTunel[6].PeorGravedad])
                            .attr("stroke", "black").attr("stroke-width", 1);
                    };

                    angular.element(document).ready(function () {
                        $scope.dibujarGrafico();
                        $scope.ocultar('loader-seguimiento-seccion');
                    });
                });

            $scope.actualizarSeccion = function (seccionSeleccionada) {
                $scope.mostrar('loader-seguimiento-seccion');
                inspeccionesService.getDañosPorSeccionPosicion($scope.InspeccionId, seccionSeleccionada, $scope.seccion)
                    .then(function (response) {
                        //var colorInferior;
                        //var colorSuperior;
                        //var colorLateral;
                        $scope.danosTunel = response.data.Posiciones;
                        var diccionario = { 'Leve': 'rgba(0, 128, 0, 0.7)', 'Moderado': 'rgba(255, 255, 0, 0.7)', 'Severo': 'rgba(255, 165, 0, 0.7)', 'Critico': 'rgba(255, 0, 0, 0.7)', '-': 'rgba(25, 31, 52, 0.2)' };

                        $scope.seccionesTunelRevest = [
                            { startAngle: -Math.PI / 2, endAngle: -Math.PI / 4, color: diccionario[$scope.danosTunel[3].PeorGravedad] }, // Hastial Izq
                            { startAngle: -Math.PI / 4, endAngle: Math.PI / 4, color: diccionario[$scope.danosTunel[1].PeorGravedad] }, // Bóveda Superior Revestimiento
                            { startAngle: Math.PI / 4, endAngle: Math.PI / 2, color: diccionario[$scope.danosTunel[5].PeorGravedad] }, // Hastial Der
                        ];

                        $scope.seccionesTunelPP = [
                            { startAngle: -Math.PI / 2, endAngle: -Math.PI / 4, color: diccionario[$scope.danosTunel[2].PeorGravedad] }, // Hastial Izq
                            { startAngle: -Math.PI / 4, endAngle: Math.PI / 4, color: diccionario[$scope.danosTunel[0].PeorGravedad] }, // Bóveda Superior PP
                            { startAngle: Math.PI / 4, endAngle: Math.PI / 2, color: diccionario[$scope.danosTunel[4].PeorGravedad] }, // Hastial Der
                        ];

                        $scope.dibujarGrafico = function () {
                            var width = 700, height = 300;
                            var svg = d3.select("#tunnelChart").attr("width", width).attr("height", height);

                            // Limpiar el SVG antes de volver a dibujar
                            svg.selectAll("*").remove();

                            var centerX = width / 2, centerY = height * 0.8, radiusPP = 180, radiusRevest = 150;

                            var arcRevest = d3.arc()
                                .innerRadius(radiusPP)
                                .outerRadius(radiusPP + 30);

                            var arcPP = d3.arc()
                                .innerRadius(radiusRevest)
                                .outerRadius(radiusRevest + 30);

                            $scope.seccionesTunelRevest.forEach(function (section) {


                                svg.append("path")
                                    .attr("d", arcPP({ startAngle: section.startAngle, endAngle: section.endAngle }))
                                    .attr("transform", "translate(" + centerX + "," + centerY + ")")
                                    .attr("fill", section.color)
                                    .attr("stroke", "black").attr("stroke-width", 1);
                            });

                            $scope.seccionesTunelPP.forEach(function (section) {

                                svg.append("path")
                                    .attr("d", arcRevest({ startAngle: section.startAngle, endAngle: section.endAngle }))
                                    .attr("transform", "translate(" + centerX + "," + centerY + ")")
                                    .attr("fill", section.color)
                                    .attr("stroke", "black").attr("stroke-width", 1);
                            });

                            // Dibujar la base del túnel PP
                            svg.append("rect")
                                .attr("x", centerX - radiusPP - 30)
                                .attr("y", centerY)
                                .attr("width", radiusPP * 2 + 60)
                                .attr("height", 25)
                                .attr("fill", diccionario[$scope.danosTunel[7].PeorGravedad])
                                .attr("stroke", "black").attr("stroke-width", 1);


                            // Dibujar la base del túnel Revestimiento
                            svg.append("rect")
                                .attr("x", centerX - radiusPP - 30)
                                .attr("y", centerY + 25)
                                .attr("width", radiusPP * 2 + 60)
                                .attr("height", 25)
                                .attr("fill", diccionario[$scope.danosTunel[6].PeorGravedad])
                                .attr("stroke", "black").attr("stroke-width", 1);
                        };

                        angular.element(document).ready(function () {
                            $scope.dibujarGrafico();
                            $scope.ocultar('loader-seguimiento-seccion');
                        });
                    });
            }



            $scope.actualizarSeccionTamano = function () {
                $scope.mostrar('loader-seguimiento-seccion');
                inspeccionesService.getSecciones($scope.InspeccionId, $scope.seccion)
                    .then(function (response) {
                        $scope.secciones = response.data;
                    });

                // Limpiar manualmente el canvas para evitar residuos
                var canvas = document.getElementById('graficoDaniosPorSeccion');
                var ctxSec = canvas.getContext('2d');
                ctxSec.clearRect(0, 0, canvas.width, canvas.height);

                inspeccionesService.getDañosPorSeccion($scope.InspeccionId, $scope.seccion)
                    .then(function (response) {
                        $scope.dañosSeccion = response.data;

                        // Generar dinámicamente los labels y los datos basados en $scope.daños
                        const labelsSec = $scope.dañosSeccion.map(function (d) {
                            return d.Seccion || 0;
                        });

                        const dataLeveSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[0].Conteo || null;
                        });

                        const dataModSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[1].Conteo || null;
                        });

                        const dataSevSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[2].Conteo || null;
                        });

                        const dataCritSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[3].Conteo || null;
                        });



                        //const labelsSeccion = { count: 7 };
                        const dataSec = {
                            labels: labelsSec,
                            datasets: [
                                {
                                    label: 'Leve',
                                    data: dataLeveSec,
                                    backgroundColor: 'rgba(0, 128, 0, 0.7)',
                                },
                                {
                                    label: 'Moderado',
                                    data: dataModSec,
                                    backgroundColor: 'rgba(255, 255, 0, 0.7)',
                                },
                                {
                                    label: 'Severo',
                                    data: dataSevSec,
                                    backgroundColor: 'rgba(255, 165, 0, 0.7)',
                                },
                                {
                                    label: 'Critico',
                                    data: dataCritSec,
                                    backgroundColor: 'rgba(255, 0, 0, 0.7)',
                                },
                            ]
                        };

                        const configSec = {
                            type: 'bar',
                            data: dataSec,
                            options: {
                                plugins: {
                                    title: {
                                        display: true,
                                        text: 'Distribución de Daños por Sección',
                                        font: {
                                            size: 16
                                        }
                                    },
                                    tooltip: {
                                        mode: 'index', // Muestra todos los valores en la misma posición de X
                                        intersect: false, // Tooltip se activa en toda la barra
                                        callbacks: {
                                            title: function () {
                                                return ''; // Oculta el valor del eje X en el tooltip
                                            },
                                            label: function (tooltipItem) {
                                                // Si el valor es null o 0, no mostrarlo
                                                if (tooltipItem.raw === null || tooltipItem.raw === 0) {
                                                    return null; // No devuelve nada (se oculta en el tooltip)
                                                }
                                                return tooltipItem.dataset.label + ': ' + tooltipItem.raw;
                                            }
                                        }
                                    }
                                },
                                interaction: {
                                    mode: 'index',
                                    intersect: false
                                },
                                responsive: true,
                                scales: {
                                    x: {
                                        stacked: true,
                                        title: {
                                            display: true,
                                            text: 'Sección (metros)', // Etiqueta del eje X
                                            font: {
                                                size: 14
                                            }
                                        },
                                        ticks: {
                                            align: 'start' // Alinea las etiquetas al inicio de cada sección
                                        },
                                        grid: {
                                            drawBorder: true,
                                            drawOnChartArea: false, // Dibuja la línea en el eje X
                                            drawTicks: true
                                        }
                                    },
                                    y: {
                                        stacked: true,
                                        title: {
                                            display: true,
                                            text: 'Cantidad de Daños', // Etiqueta del eje Y
                                            font: {
                                                size: 14
                                            }
                                        }
                                    }
                                },
                            }
                        };

                        if ($scope.damageBarChartSeccion) {
                            $scope.damageBarChartSeccion.destroy();
                        }

                        const ctxSec = document.getElementById('graficoDaniosPorSeccion').getContext('2d');
                        $scope.damageBarChartSeccion = new Chart(ctxSec, configSec);
                        $scope.ocultar('loader-seguimiento-seccion');
                    });


                inspeccionesService.getDañosPorPosicion($scope.InspeccionId, $scope.seccion)
                    .then(function (response) {
                        $scope.danosTunel = response.data;
                        var diccionario = { 'Leve': 'rgba(0, 128, 0, 0.7)', 'Moderado': 'rgba(255, 255, 0, 0.7)', 'Severo': 'rgba(255, 165, 0, 0.7)', 'Critico': 'rgba(255, 0, 0, 0.7)', '-': 'rgba(25, 31, 52, 0.2)' };

                        $scope.seccionesTunelRevest = [
                            { startAngle: -Math.PI / 2, endAngle: -Math.PI / 4, color: diccionario[$scope.danosTunel[3].PeorGravedad] }, // Hastial Izq
                            { startAngle: -Math.PI / 4, endAngle: Math.PI / 4, color: diccionario[$scope.danosTunel[1].PeorGravedad] }, // Bóveda Superior
                            { startAngle: Math.PI / 4, endAngle: Math.PI / 2, color: diccionario[$scope.danosTunel[5].PeorGravedad] }, // Hastial Der
                        ];

                        $scope.seccionesTunelPP = [
                            { startAngle: -Math.PI / 2, endAngle: -Math.PI / 4, color: diccionario[$scope.danosTunel[2].PeorGravedad] }, // Hastial Izq
                            { startAngle: -Math.PI / 4, endAngle: Math.PI / 4, color: diccionario[$scope.danosTunel[0].PeorGravedad] }, // Bóveda Superior
                            { startAngle: Math.PI / 4, endAngle: Math.PI / 2, color: diccionario[$scope.danosTunel[4].PeorGravedad] }, // Hastial Der
                        ];

                        $scope.dibujarGrafico = function () {
                            var width = 700, height = 300;
                            var svg = d3.select("#tunnelChart").attr("width", width).attr("height", height);

                            // Limpiar el SVG antes de volver a dibujar
                            svg.selectAll("*").remove();

                            var centerX = width / 2, centerY = height * 0.8, radiusPP = 180, radiusRevest = 150;

                            var arcRevest = d3.arc()
                                .innerRadius(radiusPP)
                                .outerRadius(radiusPP + 30);

                            var arcPP = d3.arc()
                                .innerRadius(radiusRevest)
                                .outerRadius(radiusRevest + 30);

                            $scope.seccionesTunelRevest.forEach(function (section) {


                                svg.append("path")
                                    .attr("d", arcPP({ startAngle: section.startAngle, endAngle: section.endAngle }))
                                    .attr("transform", "translate(" + centerX + "," + centerY + ")")
                                    .attr("fill", section.color)
                                    .attr("stroke", "black").attr("stroke-width", 1);
                            });

                            $scope.seccionesTunelPP.forEach(function (section) {

                                svg.append("path")
                                    .attr("d", arcRevest({ startAngle: section.startAngle, endAngle: section.endAngle }))
                                    .attr("transform", "translate(" + centerX + "," + centerY + ")")
                                    .attr("fill", section.color)
                                    .attr("stroke", "black").attr("stroke-width", 1);
                            });

                            // Dibujar la base del túnel Revestimiento
                            svg.append("rect")
                                .attr("x", centerX - radiusPP - 30)
                                .attr("y", centerY + 25)
                                .attr("width", radiusPP * 2 + 60)
                                .attr("height", 25)
                                .attr("fill", diccionario[$scope.danosTunel[6].PeorGravedad])
                                .attr("stroke", "black").attr("stroke-width", 1);

                            // Dibujar la base del túnel PP
                            svg.append("rect")
                                .attr("x", centerX - radiusPP - 30)
                                .attr("y", centerY)
                                .attr("width", radiusPP * 2 + 60)
                                .attr("height", 25)
                                .attr("fill", diccionario[$scope.danosTunel[7].PeorGravedad])
                                .attr("stroke", "black").attr("stroke-width", 1);

                        };

                        angular.element(document).ready(function () {
                            $scope.dibujarGrafico();
                            $scope.ocultar('loader-seguimiento-seccion');
                        });
                    });
            }


            $scope.actualizarSeccionTamanoPK = function () {
                $scope.mostrar('loader-seguimiento-seccion');
                inspeccionesService.getDañosPorPK($scope.inspeccion.Id, $scope.seccion)
                    .then(function (response) {
                        $scope.damagesporpk = response.data;
                        $scope.ocultar('loader-seguimiento-seccion');
                    });
            }


            $scope.updateTooltip = function (event, clase, rango) {
                var tooltip = document.getElementById(clase);
                var slider = document.getElementById(rango);
                // Obtener la posición del mouse respecto al slider
                var rect = slider.getBoundingClientRect();
                var offsetX = event.clientX - rect.left; // Distancia desde el inicio del slider
                var sliderWidth = rect.width; // Ancho total del slider
                // Calcular el valor correspondiente a la posición del mouse
                var percent = offsetX / sliderWidth; // Proporción del slider donde está el cursor
                var range = $scope.max - $scope.min; // Rango total de valores
                var selectedValue = Math.round(($scope.min + percent * range) / $scope.step) * $scope.step; // Ajustar al step
                // Asegurar que el valor esté dentro del rango permitido
                selectedValue = Math.max($scope.min, Math.min($scope.max, selectedValue));
                // Posicionar el tooltip cerca del cursor
                if (clase == "tooltipSlider") {
                    tooltip.style.left = (event.pageX - 300) + "px";
                    tooltip.style.top = (event.pageY - 160) + "px"; // Ajuste para que no cubra el cursor
                }
                else {
                    tooltip.style.left = (event.pageX - 800) + "px";
                    tooltip.style.top = (event.pageY - 220) + "px"; // Ajuste para que no cubra el cursor
                }
                // Mostrar el valor dentro del tooltip
                tooltip.innerHTML = selectedValue + " m";
                // Mostrar el tooltip
                tooltip.style.display = "block";
            };
            // Función para ocultar el tooltip cuando el mouse sale del slider
            $scope.hideTooltip = function (clase) {
                //var tooltip = document.getElementById("tooltipSlider");
                var tooltip = document.getElementById(clase);
                tooltip.style.display = "none";
            };


        }
    ]);
